import type {
  NavItem,
  Partner,
  SocialLink,
  Stat,
  Testimonial,
  WhyChooseItem,
} from "./types";

export const site = {
  name: "Kasa Chemicals",
  legalName: "Kasa Chemicals Private Limited",
  tagline: "A Complete Building Solution",
  description:
    "Manufacturer of stone care, tile adhesives, cleaners, and waterproofing chemicals in Jaipur.",
  url: "https://www.kasachemicals.com",
  logo: "/images/brand/kasa.logo.png",
  address: "230, New Aatish Market, Mansarovar, Jaipur, 302020",
  phone: "+919116615669",
  phoneDisplay: "+91 91166 15669",
  email: "info@kasachemicals.com",
  dealerLogin: "/dealer-login",
  customerLogin: "/customer-login",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.816470175858!2d75.76127!3d26.8775715!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db45632712bbb%3A0xb4c765050dfbab72!2sKasa%20chemicals%20private%20limited!5e0!3m2!1sen!2sin!4v1744638182538!5m2!1sen!2sin",
};

export const nav: NavItem[] = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/products", label: "Products" },
];

export const socials: SocialLink[] = [
  {
    href: "https://www.facebook.com/share/1MdWaL93Fg/",
    label: "Facebook",
  },
  {
    href: "https://www.instagram.com/kasa_chemicals/",
    label: "Instagram",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "Mukund Gawde",
    role: "Homeowner",
    quote:
      "The waterproofing treatment is absolutely fantastic. It has been 4 years and we have completely solved the issue. Earlier we felt it was expensive, but after 4 years the results speak.",
  },
  {
    name: "Kishore Kumar",
    role: "Project Manager",
    quote:
      "I wanted to express my appreciation for the excellent work done by the team at Kasa. Kasa performed professionally with good on-site project management skills.",
  },
  {
    name: "Anita Sharma",
    role: "Interior Contractor",
    quote:
      "We use Kasa tile adhesives and stone cleaners on most of our sites. Bonding is consistent, surfaces stay clean, and the technical team is always quick to guide us on the right product.",
  },
  {
    name: "Rahul Mehta",
    role: "Builder",
    quote:
      "From waterproofing chemicals to adhesives, Kasa has become our go-to brand in Jaipur. Delivery is reliable and the formulations hold up well under site conditions.",
  },
];

export const partners: Partner[] = [
  { src: "/images/clients/since-1995.png", alt: "Since 1995" },
  { src: "/images/clients/partner-blu.webp", alt: "Blubuzz Media" },
  { src: "/images/clients/partner-3.png", alt: "A Lucky Angel's Academy" },
];

export const stats: Stat[] = [
  {
    value: "150",
    unit: "+",
    label: "Projects Done",
    icon: "/images/icons/solar.svg",
  },
  {
    value: "25",
    unit: "K",
    label: "Happy Clients",
    icon: "/images/icons/rating.svg",
  },
  {
    value: "30",
    unit: "+",
    label: "Expert Staff",
    icon: "/images/icons/staff.svg",
  },
  {
    value: "50",
    unit: "+",
    label: "Awards Won",
    icon: "/images/icons/award.svg",
  },
];

export const whyChooseUs = {
  eyebrow: "Why Choose Us",
  title: "We deliver expertise you can trust",
  intro:
    "At Kasa Chemicals, we are committed to delivering excellence in every molecule. Here is why our clients choose us time and again.",
  image: "/images/about/why-choose-1.webp",
  secondaryImage: "/images/about/why-choose-2.webp",
  items: [
    {
      title: "Uncompromising Quality",
      body: "We follow strict quality control standards to ensure that every product meets international benchmarks for safety, purity, and performance.",
      icon: "/images/icons/money-2.svg",
    },
    {
      title: "Customer-Centric Approach",
      body: "We believe in building long-term partnerships. Our team provides dedicated support and tailored solutions to meet specific client requirements.",
      icon: "/images/icons/staff.svg",
    },
    {
      title: "Industry Experience",
      body: "With years of experience in the chemical industry, we understand market demands and can adapt quickly to provide cutting-edge solutions.",
      icon: "/images/icons/certified.svg",
    },
  ] satisfies WhyChooseItem[],
};

export const about = {
  title: "Kasa Chemicals",
  image: "/images/about/about-us.webp",
  facilityImage: "/images/about/facility.jpg",
  intro:
    "Kasa Chemicals is a trusted name in chemical manufacturing, known for high-quality solutions across stone care and construction. We specialize in industrial and specialty chemicals that meet the evolving needs of clients in India and beyond.",
  story:
    "Founded on strong values and technical expertise, Kasa Chemicals has grown into an organization driven by research, quality control, and customer satisfaction. Our facilities, experienced team, and quality standards keep formulations consistent from raw material to finished product.",
  values: [
    {
      title: "Quality first",
      body: "Every batch is built for bonding strength, surface safety, and lasting protection on stone and construction work.",
    },
    {
      title: "Practical chemistry",
      body: "Products are designed for real sites: stain removal, cement residue, waterproofing, and secure tile and stone fixing.",
    },
    {
      title: "Local manufacturing",
      body: "Based in Jaipur, we support contractors, fabricators, and homeowners with a complete range of building chemicals.",
    },
  ],
};

export const careers = {
  title: "Work with Kasa",
  intro:
    "We are a Jaipur-based manufacturer of stone care and construction chemicals. If you want to join production, sales, or quality teams, write to us with a short note about the role you are looking for.",
  note: "There is no open listing published on this site. Email your interest and we will reply if there is a fit.",
};
